import { List } from "immutable";
import * as actions from "../actions/CareerCenterActions";
import { CareerCenterState, initialState } from "../store/CareerCenterState";
import buildReducer from "../utils/ReducerBuilder";

export const CareerCenterReducer = buildReducer<CareerCenterState>(initialState)
    .handle(actions.onAllJobsReceived, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            jobs: List(action.payload.jobs),
        };
    })
    .handle(actions.onAllResumesReceived, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            resumes: List(action.payload.resumes),
        };
    })
    .handle(actions.onAllUserJobsReceived, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            userJobs: List(action.payload.jobs),
        };
    })
    .handle(actions.onAllUserResumesReceived, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            userResumes: List(action.payload.resumes),
        };
    })
    .handle(actions.onUserSubscriptionsReceived, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            userSubscriptions: action.payload,
        };
    })
    .handle(actions.toggleJobsLoading, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            loadingJobs: action.payload,
        };
    })
    .handle(actions.toggleResumesLoading, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            loadingResumes: action.payload,
        };
    })
    .handle(actions.updateJobs, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            jobs: action.payload,
        };
    })
    .handle(actions.updateResumes, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            resumes: action.payload,
        };
    })
    .handle(actions.updateUserJobs, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            userJobs: action.payload,
        };
    })
    .handle(actions.updateUserJobSubscriptions, (state, action) => {
        if (action.payload === undefined)
            return state;

        const userSubscriptions = { ...state.userSubscriptions };
        userSubscriptions.jobPostCategoryIds = action.payload;

        return {
            ...state,
            userSubscriptions,
        };
    })
    .handle(actions.updateUserResumes, (state, action) => {
        if (action.payload === undefined)
            return state;

        return {
            ...state,
            userResumes: action.payload,
        };
    })
    .handle(actions.updateUserResumeSubscriptions, (state, action) => {
        if (action.payload === undefined)
            return state;

        const userSubscriptions = { ...state.userSubscriptions };
        userSubscriptions.resumeCategoryIds = action.payload;

        return {
            ...state,
            userSubscriptions,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/reducers/CareerCenterReducer.ts